export default {
  highlightedAnnotationHovered: (state: any) =>
    state.highlightedAnnotation.hover,
  highlightedAnnotationClicked: (state: any) =>
    state.highlightedAnnotation.click,
  skillDescriptionActive: (state: any) =>
    state.skillDescription.hover || state.skillDescription.click,
  skillDescription: (state: any) => state.skillDescription,
};
